<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="keyword" placeholder="请输入transaction_id"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="callback_response"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.callback_response ==null ? 'null' : scope.row.callback_response }}</span>
        </template>
      </el-table-column>

      <el-table-column label="callback_status" width="">
        <template slot-scope="scope">
          <span>{{scope.row.callback_status ==null ? 'null' : scope.row.callback_status}}</span>
          <!-- <a :href="'#'" target="_blank">查看</a> -->
        </template>
      </el-table-column>
     <el-table-column label="batchId" width="">
        <template slot-scope="scope">
          <span>{{batchId}}</span>
          <div v-on:click="toggle()">
               <a href="#">查看appList的数据</a>
          </div>
         <div v-on:click="reveal()">
              <a>查看repayAcctInfoList的数据</a>
          </div>
         
        </template>
      </el-table-column>
     <!-- <el-table-column label="request" width="">
        <template slot-scope="scope">
          <span>{{scope.row.request}}</span>
        </template>
      </el-table-column>-->
      
      <el-table-column label="response" width="">
        <template slot-scope="scope">
          <p>{{scope.row.response.resCode}}</p>
          <p>{{scope.row.response.resData == null ? 'null' : scope.row.response.resData}}</p>
          <p>{{scope.row.response.resMsg}}</p>
        </template>
      </el-table-column>

      <el-table-column label="status" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="masklayer" id="mask" v-show="mask" style="height: 995px;">
      <span class="cross" v-on:click="cross()">关闭</span>
    </div>
    
    <div class="appList"  v-show="isshowAppList">
      <el-table :data="applists" highlight-current-row  v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.appId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="cumId" width="">
        <template slot-scope="scope">
         <span>{{scope.row.cumId}}</span>
        </template>
      </el-table-column>

     <el-table-column label="卡号" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.identity}}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="instCode" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.instCode}}</span>
        </template>
      </el-table-column>

      <el-table-column label="手机号" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="还款方式" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="还款金额" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.repAmt }}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    <div class="RepayAcctInfoList" v-show="isshowRepayAcctInfoList">
       <el-table :data="contracts" highlight-current-row  v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="银行"
        width="">
        <template slot-scope="scope">
          <span>{{ actBank }}</span>
        </template>
      </el-table-column>

      <el-table-column label="银行卡号" width="">
        <template slot-scope="scope">
          <span>{{ actCode }}</span>
        </template>
      </el-table-column>

     <el-table-column label="银行卡预留姓名" width="">
        <template slot-scope="scope">
          <span>{{ actName }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="姓名" width="">
        <template slot-scope="scope">
          <span>{{ createUser }}</span>
        </template>
      </el-table-column>

      <el-table-column label="类型" min-width="">
        <template slot-scope="scope">
          <span>{{ remark }}</span>
        </template>
      </el-table-column>
        <el-table-column label="总金额" min-width="">
        <template slot-scope="scope">
          <span>{{ repAmt }}</span>
        </template>
      </el-table-column>
        <el-table-column label="还款时间" min-width="">
        <template slot-scope="scope">
          <span>{{ repTime }}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
    import { getRepaymentList } from '../../api/api';
    export default {
      data() {
        return {
          keyword: '',
          //===有分页会用到
          currentPage: 1,
          listLoading: false,
          total_count: 0,
          pagination: true,
          isshowAppList:false,
          isshowRepayAcctInfoList: false,
          mask:false,
          //=====
           contracts: [],
           applists : [],
           batchId  : "",
           remark   : "",
           actName  : "",
           actBank  : "",
           actCode  : "",
           repAmt   : "",
           repTime  : "",
           createUser:""

        }
      },
      methods: {
        getUsers() {
          let params = {
            'transaction_id': this.keyword,
          };
          getRepaymentList(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.pay_logs
              this.applists = res.data.pay_logs[0].request.appList
              this.batchId = res.data.pay_logs[0].request.batchId
              this.actBank = res.data.pay_logs[0].request.repayAcctInfoList[0].actBank
              this.remark  = res.data.pay_logs[0].request.repayAcctInfoList[0].remark
              this.actName = res.data.pay_logs[0].request.repayAcctInfoList[0].actName
              this.createUser = res.data.pay_logs[0].request.repayAcctInfoList[0].createUser
              this.actCode = res.data.pay_logs[0].request.repayAcctInfoList[0].actCode
              this.repAmt =  res.data.pay_logs[0].request.repayAcctInfoList[0].repAmt
              this.repTime =  res.data.pay_logs[0].request.repayAcctInfoList[0].repTime
              this.total_count =res.data.pay_logs[0].request.repayAcctInfoList.length
            }
          })
        },
        handleCurrentChange(val) {
          this.getUsers();
          this.currentPage = val;
        },
        toggle:function(){
          this.mask =! this.mask;
          this.isshowAppList =! this.isshowAppList;
        },
        reveal:function(){
          this.mask =! this.mask;
          this.isshowRepayAcctInfoList =! this.isshowRepayAcctInfoList;
        },
        cross:function(){
           this.mask = false;
           this.isshowAppList =false;
           this.isshowRepayAcctInfoList =false;
        }
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/RepaymentUse.vue